import { render, staticRenderFns } from "./increaseInApp.vue?vue&type=template&id=3ad364e6&scoped=true"
import script from "./increaseInApp.vue?vue&type=script&lang=js"
export * from "./increaseInApp.vue?vue&type=script&lang=js"
import style0 from "./increaseInApp.vue?vue&type=style&index=0&id=3ad364e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad364e6",
  null
  
)

export default component.exports